var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTick = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.86015 17.9028L10.218 18.252C10.1223 18.35 9.99052 18.4045 9.8535 18.4027C9.71648 18.4009 9.58621 18.3429 9.49315 18.2423L9.86015 17.9028ZM4.44441 11.3133L10.2272 17.5632L9.49315 18.2423L3.7104 11.9924L4.44441 11.3133ZM9.50231 17.5535L20.1422 6.65079L20.8578 7.34921L10.218 18.252L9.50231 17.5535Z",
  fill: "#A2A9AD"
})));
export { SvgTick as ReactComponent };
export default __webpack_public_path__ + "images/tick.svg";